import {
  INotification,
  notificationEnums,
} from "@freetech/models/notifications";
import {
  getStakeholderNotificationDescription,
  getFreelancerNotificationDescription,
  getAdminNotificationDescription,
  getFreeloNotificationDescription,
} from "./modules";

export const getNotificationDescription = (
  notification: INotification
): string | undefined => {
  const { type, afterData, beforeData } = notification;

  if (
    Object.values(notificationEnums.StakeholderNotificationType).includes(
      type as any
    )
  ) {
    return getStakeholderNotificationDescription(notification);
  }

  if (
    Object.values(notificationEnums.FreelancerNotificationType).includes(
      type as any
    )
  ) {
    return getFreelancerNotificationDescription(notification);
  }

  if (
    Object.values(notificationEnums.AdminNotificationType).includes(type as any)
  ) {
    return getAdminNotificationDescription(notification);
  }

  if (
    Object.values(notificationEnums.FreeloNotificationType).includes(
      type as any
    )
  ) {
    return getFreeloNotificationDescription(notification);
  }

  if (afterData && "description" in afterData && afterData.description) {
    return afterData.description as string;
  }

  if (beforeData && "description" in beforeData && beforeData.description) {
    return beforeData.description as string;
  }

  return undefined;
};
